import React from "react";
import { useTranslation } from "react-i18next";

const TabMenu = ({ tabs = [], value, onTabClick, seniorLayout }) => {
  const { t } = useTranslation();

  return (
    <div
      className={`w-full flex font-semibold text-gray-500 overflow-x-auto no-scrollbars border-b border-gray-300
        ${seniorLayout ? "text-2xl" : "text-lg"}`}
    >
      {tabs.map((tab,index) => (
        <div
          key={tab.key}
          className={`px-2 py-3 flex-1 cursor-pointer text-center whitespace-nowrap
            ${value === tab.value ? "text-black border-b-4 border-primary" : "text-gray-400"}`}
          onClick={() => onTabClick(tab.key)}

        >
          {t(tab.label)}
        </div>
      ))}
    </div>
  );
};


export default TabMenu;
